import {Component, OnInit} from '@angular/core';
import {StorageService} from 'app/shared/services/storage.service';
import {StockistService} from '../../shared/services/stockist.service';
import {AddressService} from '../../shared/services/address.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {StateService} from '../../shared/services/state.service';
import {AlertService} from '../../shared/services/alert.service';
import {CartService} from '../../shared/services/cart.service';
import {OrderService} from '../../shared/services/order.service';
import {Router} from '@angular/router';
import {DataService} from '../../shared/services/data.service';
import {AppConstants} from '../../shared/constants/app-constant';

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
    submitted: any = false;
    submitted_loader: any = false;
    addAddressForm: FormGroup;
    user: any;
    userData: any;
    states = [];
    updateAddressModal: any = false;
    deleteAddressModal: any = false;
    addresses: any = [];
    selectedAddress: any;
    cartProducts: any = [];
    grandTotalAmount: any = 0;
    addressId: any;
    placeOrderModal: any = false;
    orderPlacing: any = false;
    orderPlaced: any = false;
    unAvailableProducts: any = [];
    imageBaseUrl: any = AppConstants.BUCKET_URL;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };

    constructor(private stockistService: StockistService,
                private addressService: AddressService,
                private stateService: StateService,
                public alertService: AlertService,
                private cartService: CartService,
                private orderService: OrderService,
                private router: Router,
                public modalService: NgbModal,
                private dataService: DataService,
                private fb: FormBuilder) {
        this.user = StorageService.getItem('self');
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.addAddressForm = this.fb.group({
            'name': ['', Validators.required],
            'contact': ['', Validators.required],
            'address': ['', Validators.required],
            'city': ['', Validators.required],
            'state_id': ['', Validators.required],
            'pin_code': ['', Validators.required],
            'gst_no': ['', [Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/)]],
        });
        this.getCartItems();
    }

    getCartItems() {
        this.cartProducts = [];
        this.cartService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.cartProducts = data['data'];
                let grandTotalAmount = 0;
                this.cartProducts.forEach(cartProduct => {
                    cartProduct['tax_amount'] = ((parseFloat(cartProduct['distributed_price']) * parseFloat(cartProduct['tax'])) / 100) * parseFloat(cartProduct['quantity']);
                    cartProduct['unit_tax_amount'] = ((parseFloat(cartProduct['distributed_price']) * parseFloat(cartProduct['tax'])) / 100);
                    cartProduct['amount'] = ((parseFloat(cartProduct['distributed_price'])) * parseFloat(cartProduct['quantity']));
                    cartProduct['total_amount'] = ((parseFloat(cartProduct['amount'])) + parseFloat(cartProduct['tax_amount']));
                    cartProduct['quantity_available'] = true;
                    grandTotalAmount = grandTotalAmount + cartProduct['total_amount'];
                });
                this.grandTotalAmount = grandTotalAmount;
                this.getState();
            } else {
                this.router.navigateByUrl('products');
            }
        }, error => {
            this.router.navigateByUrl('products');
        });
    }

    getState() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
                this.getStockistDetail();
            }
        });
    }

    getStockistDetail() {
        this.stockistService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                this.getAddress();
            }
        });
    }

    getAddress() {
        this.addressService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.addresses = data['data'];
            }
        });
    }

    openAddAddressModal(content) {
        this.updateAddressModal = true;
        this.addAddressForm.patchValue({
            'name': '',
            'contact': '',
            'address': '',
            'city': '',
            'state_id': '',
            'pin_code': '',
            'gst_no': '',
        });
        this.modalService.open(content, {'size': 'lg'});
    }

    addAddress() {
        this.submitted = true;
        if (!this.addAddressForm.valid) {
            return;
        }
        if (this.submitted) {
            this.addressService.create(this.addAddressForm.value).subscribe(data => {
                this.submitted = false;
                this.modalService.dismissAll('');
                this.getAddress();
            }, error => {
                this.submitted = false;
            });
        }
    }

    openUpdateAddressModal(content, address) {
        this.updateAddressModal = true;
        this.selectedAddress = address;
        this.modalService.open(content, {'size': 'lg'});
        this.addAddressForm.patchValue({
            'name': (address && address.name) ? address.name : '',
            'contact': (address && address.contact) ? address.contact : '',
            'address': (address && address.address) ? address.address : '',
            'city': (address && address.city) ? address.city : '',
            'state_id': (address && address.state_id) ? address.state_id : '',
            'pin_code': (address && address.pin_code) ? address.pin_code : '',
            'gst_no': (address && address.gst_no) ? address.gst_no : '',
        });
    }

    openDeleteAddressModal(content, address) {
        this.deleteAddressModal = true;
        this.selectedAddress = address;
        this.modalService.open(content, {'size': 'lg'});
    }

    updateAddress() {
        this.submitted = true;
        if (!this.addAddressForm.valid) {
            return;
        }
        if (this.submitted) {
            this.addressService.update(this.selectedAddress.unique_id, this.addAddressForm.value).subscribe(data => {
                this.submitted = false;
                this.modalService.dismissAll('');
                this.getAddress();
            }, error => {
                this.submitted = false;
            });
        }
    }

    chooseDeliveryAddress(address) {
        if (this.addresses && this.addresses.length > 0) {
            this.addresses.forEach(address => {
                address['selected'] = false;
            });
            address['selected'] = true;
        }
    }

    removeFromCart(product) {
        this.cartService.delete(product.product.id).subscribe(data => {
            this.modalService.dismissAll('');
            this.dataService.sendMessage('GET_CART_ITEMS');
            this.getCartItems();
        }, error => {
            this.submitted = false;
        });
    }

    chooseAddressId() {
        if (this.addresses && this.addresses.length > 0) {
            let addressId: any;
            this.addresses.forEach(address => {
                if (address['selected'] === true) {
                    addressId = address.id;
                }
            });
            this.addressId = addressId;
            setTimeout(this.scrollPageToBottom, 1000);
        }
    }

    scrollPageToBottom() {
        window.scrollTo(0, document.body.scrollHeight);
    }

    openPlaceOrderModal(content) {
        this.placeOrderModal = true;
        this.modalService.open(content, {'size': 'sm'});
    }

    placeOrder() {
        this.submitted_loader = true;
        if (this.cartProducts && this.cartProducts.length > 0) {
            let products = [];
            this.cartProducts.forEach(cartProduct => {
                products.push({
                    'name': (cartProduct && cartProduct.name) ? cartProduct.name : '',
                    'product_id': (cartProduct && cartProduct.product_id) ? cartProduct.product_id : '',
                    'quantity': (cartProduct && cartProduct.quantity) ? cartProduct.quantity : '',
                    'mrp': (cartProduct && cartProduct.mrp) ? cartProduct.mrp : '',
                    'distributed_price': (cartProduct && cartProduct.distributed_price) ? cartProduct.distributed_price : '',
                    'basic_value': (cartProduct && cartProduct.basic_value) ? cartProduct.basic_value : '',
                    'image': (cartProduct && cartProduct.product && cartProduct.product.image && cartProduct.product.image.id) ? cartProduct.product.image.id : '',
                    'image_url': (cartProduct && cartProduct.product && cartProduct.product.image && cartProduct.product.image.partial_url) ? cartProduct.product.image.partial_url : '',
                    'type': (cartProduct && cartProduct.product && cartProduct.product.type) ? cartProduct.product.type : '',
                    'description': (cartProduct && cartProduct.product && cartProduct.product.description) ? cartProduct.product.description : '',
                    'hsn': (cartProduct && cartProduct.hsn) ? cartProduct.hsn : '',
                    'tax': (cartProduct && cartProduct.tax) ? cartProduct.tax : '',
                    'batch': (cartProduct && cartProduct.batch) ? cartProduct.batch : '',
                    'added_by': (cartProduct && cartProduct.product && cartProduct.product.added_by) ? cartProduct.product.added_by : '',
                    'session_id': (cartProduct && cartProduct.product && cartProduct.product.session_id) ? cartProduct.product.session_id : ''
                });
            });
            if (products && products.length > 0) {
                this.orderPlacing = true;
                this.orderPlaced = false;
                this.orderService.add({'products': products, 'address_id': this.addressId}).subscribe(data => {
                    this.submitted_loader = false;
                    this.clearAllCartItems();
                }, error => {
                    this.submitted_loader = false;
                    this.orderPlacing = false;
                    this.orderPlaced = false;
                    if (error && error['error'] && error['error']['error']) {
                        if (error && error['error'] && error['error']['error'] && error['error']['errorData'] && error['error']['errorData'].length > 0) {
                            this.unAvailableProducts = error['error']['errorData'];
                            if (this.unAvailableProducts && this.unAvailableProducts.length > 0) {
                                let cartProducts = this.cartProducts;
                                let unAvailableProducts = this.unAvailableProducts;
                                if (cartProducts && cartProducts.length > 0) {
                                    cartProducts.forEach(cartProduct => {
                                        if (cartProduct && cartProduct.id) {
                                            if (unAvailableProducts && unAvailableProducts.length > 0) {
                                                unAvailableProducts.forEach(unAvailableProduct => {
                                                    if (unAvailableProduct && unAvailableProduct.product_id) {
                                                        if (cartProduct && (cartProduct['product_id'] === unAvailableProduct['product_id'])) {
                                                            cartProduct['quantity_available'] = false;
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    });
                                    this.cartProducts = cartProducts;
                                }
                                this.modalService.dismissAll('');
                            }
                            this.alertService.showErrors(error['error']['error']);
                            return;
                        } else {
                            this.alertService.showErrors(error['error']['error']);
                            return;
                        }
                    }
                });
            } else {
                this.alertService.showErrors('Something went wrong');
            }
        } else {
            this.alertService.showErrors('Product not found');
        }
    }

    clearAllCartItems() {
        this.cartService.deleteAll().subscribe(data => {
            this.alertService.showSuccess({title: 'Success', message: 'Order Placed Successfully'});
            this.orderPlacing = false;
            this.orderPlaced = true;
            this.dataService.sendMessage('GET_CART_ITEMS');
            setTimeout(this.redirectToOrder, 2000);
        });
    }

    redirectToOrder() {
        window.location.href = 'my-orders';
    }

    deleteAddress() {
        this.addressService.delete(this.selectedAddress.unique_id).subscribe(data => {
            this.modalService.dismissAll('');
            this.getAddress();
            this.getCartItems();
        }, error => {
            this.submitted = false;
        });
    }
}
